export default "__VITE_ASSET__2548a0e3__"